export default function initTabs(elem) {
  if (!document.querySelector(elem)) {
    return;
  }
  document.querySelector(elem).addEventListener('click', function (event) {
    if (!event.target.matches(`${elem} .tab-trigger`)) return;
    else {
      const href = event.target.getAttribute('href');
      if (!event.target.classList.contains('active') && href.length > 0) {
        // remove active class from all other panels
        let elementList = document.querySelectorAll(`${elem} .tab-trigger`);
        Array.prototype.forEach.call(elementList, function (e) {
          e.classList.remove('active');
        });
        elementList = document.querySelectorAll(
          `${elem} .tab-content .tab-panel`
        );
        Array.prototype.forEach.call(elementList, function (e) {
          e.classList.remove('active');
        });
        //add active class on cliked accordion
        event.target.classList.add('active');
        const targetPanel = document.querySelector(
          `${elem} .tab-content ${href}`
        );
        if (targetPanel) {
          targetPanel.classList.add('active');

          const url = new URL(window.location.href);
          url.searchParams.set('activeTab', href.replace('#tab-', ''));
          history.replaceState(null, null, url);
        }
      }
      event.preventDefault();
    }
  });

  const activeTab = new URL(window.location.href).searchParams.get('activeTab');
  if (activeTab && activeTab.length > 0) {
    const targetPanel = document.querySelector(
      `${elem} .tab-trigger[href="#tab-${activeTab}"]`
    );
    if (targetPanel) {
      targetPanel.click();
    }
  }
}
